import { combineReducers } from "redux";
import { logInReducer, logOutReducer } from "./authReducer";
import {clinicIDReducer ,clinicStatusReducer, clinicToggleForSmsNotificationsReducer, clinicToggleForStripeReducer,clinicToggleForRCMReducer, clinicsSelectedStateReducer, clinicStatesReducer, customerStatusesReducer, selectedCustomerStatusReducer} from "./clinicReducer";
import {
  clientIDReducer,
  clientInsuranceIDReducer,
  selectedClientIdReducer,
  clientFilterReducer,
  selectedDrawer,
  clientDetails,
  getClientProfileImg,
} from "./clientReducer";

import { selectedServiceIdReducer } from "./serviceReducer";
import { announcementFiter } from "./announcementReducer";
import {
  selectedHeaderMenu,
  isGlobalSearchReducer,
  getGender,
  getRole,
  getRegion,
} from "./commonSlice";

import {
  selectedStaffIdReducer,
  getStaffReducer,
  getMaritialsStatusReducer,
  getGenderReducer,
  getStaffDetails,
  getProfileImg,
  getAllClinic,
} from "./staffReducer";

import { getdocumentType, saveDefaultDocumentTemplate } from "./documentReducer";
import {
  subpoenaRequestsReducer,
  subpoenaRequestDetailsReducer,
  subpoenaModulesReducer,
  subpoenaRegionFilterReducer,
} from "./subpoenaReducer";
import { smsLookupFilter } from "./smsLookupReducer";

const appReducer = combineReducers({
  loggedIn: logInReducer,
  loggedOut: logOutReducer,
  clinicId: clinicIDReducer,
  clientId: clientIDReducer,
  selectedDrawer: selectedDrawer,
  clientInsuranceId: clientInsuranceIDReducer,
  selectedClientId: selectedClientIdReducer,
  selectedServiceId: selectedServiceIdReducer,
  selectedStaffId: selectedStaffIdReducer,
  clientLastFilter: clientFilterReducer,
  getStaffReducer: getStaffReducer,
  getMaritialsStatusReducer: getMaritialsStatusReducer,
  getGenderReducer: getGenderReducer,
  selectedHeaderMenu: selectedHeaderMenu,
  isGlobalSearchReducer: isGlobalSearchReducer,
  getGender: getGender,
  getRole: getRole,
  clientDetails: clientDetails,
  getClientProfileImg: getClientProfileImg,
  getStaffDetails: getStaffDetails,
  getProfileImg: getProfileImg,
  // ---------------------------------Admin-----------------------------
  getAllClinic: getAllClinic,
  getRegion: getRegion,
  getdocumentType: getdocumentType,
  saveDefaultDocumentTemplate: saveDefaultDocumentTemplate,
  clinicStatusReducer:clinicStatusReducer,
  clinicsSelectedStateReducer: clinicsSelectedStateReducer,
  clinicStatesReducer: clinicStatesReducer,
  clinicToggleForStripeReducer: clinicToggleForStripeReducer,
  clinicToggleForRCMReducer: clinicToggleForRCMReducer,
  clinicToggleForSmsNotificationsReducer: clinicToggleForSmsNotificationsReducer,
  announcementFiter: announcementFiter,
  customerStatuses: customerStatusesReducer,
  smsLookupFilter: smsLookupFilter,
  subpoenaRequests: subpoenaRequestsReducer,
  subpoenaRequestDetails: subpoenaRequestDetailsReducer,
  subpoenaModules: subpoenaModulesReducer,
  subpoenaRegionFilter: subpoenaRegionFilterReducer,
  selectedCustomerStatusReducer: selectedCustomerStatusReducer,
});

export default appReducer;
